import { Button } from "@st-marketplace/ui";
import { useNavigate } from "@tanstack/react-router";

interface RelationNameLinkProps {
	name: string;
	relationId: string;
	party: "buyer" | "seller";
}

// Rendered exactly like the order email link so both look identical.
const RelationNameLink = ({
	name,
	relationId,
	party,
}: RelationNameLinkProps) => {
	const navigate = useNavigate();

	return (
		<Button
			type="button"
			variant="text"
			color="primary"
			size="sm"
			onClick={() =>
				navigate({
					to:
						party === "buyer"
							? "/relations/buyers/$relationId"
							: "/relations/sellers/$relationId",
					params: { relationId },
				})
			}
		>
			{name}
		</Button>
	);
};

export default RelationNameLink;
